import { MessageSquarePlus } from "lucide-react";

import { cn } from "@/lib/utils";
import Tooltip from "@/components/Tooltip";
import { Button } from "@/components/ui/button";
import useChatStore from "@/stores/useChatStore";

export default function HeaderNewChat({ navVisible }) {
  const loading = useChatStore((store) => store.loading);
  const handleResetChatStore = useChatStore((store) => store.handleResetChatStore);

  return (
    navVisible && (
      <Tooltip tooltipContent="New chat">
        <Button
          size="icon"
          variant="outline"
          className={cn("bg-transparent rounded-xl border border-border-light p-2 hover:bg-gray-100 border-none delayed-button")}
          onClick={handleResetChatStore}
          disabled={loading}
        >
          <MessageSquarePlus style={{ width: "24px", height: "24px" }} />
        </Button>
      </Tooltip>
    )
  );
}
